/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { createContext, useContext } from "react";

interface ApiConfig {
	serverUrl?: string;
}

const ApiConfigContext = createContext<ApiConfig>({});

export function ApiConfigProvider({
	serverUrl,
	children,
}: {
	serverUrl?: string;
	children: React.ReactNode;
}): React.JSX.Element {
	return <ApiConfigContext.Provider value={{ serverUrl }}>{children}</ApiConfigContext.Provider>;
}

export function useApiConfig(): ApiConfig {
	return useContext(ApiConfigContext);
}
